import React, { Component } from 'react';
import { Alert } from 'reactstrap';

class PermissionWrapper extends Component {

    render() {
        const { allowedPermission, userPermissions = [], hidden, children } = this.props;

        const permissionGranted = (
            allowedPermission == null ||
            allowedPermission === '' ||
            (Array.isArray(allowedPermission)
                ? allowedPermission.some(p =>
                    userPermissions.some(u => u.toUpperCase() === p.toUpperCase())
                )
                : userPermissions.some(u => u.toUpperCase() === allowedPermission.toUpperCase())
            )
        );

        return (
            <>
                {permissionGranted ? (
                    children
                ) : (
                    hidden ? null : <Alert color="danger">You do not have permission to access this resource.</Alert>
                )}
            </>
        );
    }
}

export default PermissionWrapper;
